import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const ViewPublications = () => {
    const { pubId } = useParams();
    const [publication, setPublication] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        console.log(pubId); // Log pubId to verify it's correct
        const fetchPublication = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/publications/${pubId}`);
                setPublication(response.data);
            } catch (error) {
                console.error("Error fetching publication:", error);
                setError("Failed to fetch publication details.");
            } finally {
                setLoading(false);
            }
        };

        fetchPublication();
    }, [pubId]);

    if (loading) {
        return (
            <div className="text-center">
                <span className="spinner-border spinner-border-md" role="status" aria-hidden="true"></span>
                <strong>Loading...</strong>
            </div>
        );
    }

    if (error) {
        return <div className="alert alert-danger">{error}</div>;
    }

    if (!publication) {
        return <div>No publication found.</div>;
    }

    // Combine authors into an array and filter out empty ones
    const authors = [
        publication.firstauthor,
        publication.secondauthor,
        publication.thirdauthor,
        publication.fourthauthor
    ].filter(author => author); // Filter out undefined or empty values

    return (
        <div className="container">
            <h1>{publication.title}</h1>

            <h4>Authors: {authors.length > 0 ? authors.join(', ') : 'No authors listed'}</h4>

            <p><strong>Contribution:</strong> {publication.contribution}</p>
            <p><strong>DOI:</strong> {publication.doi}</p>
            <p><strong>Journal:</strong> {publication.journal}</p>
            <p><strong>PubID:</strong> {publication.pubid}</p>
            <p><strong>Reach:</strong> {publication.reach}</p>
            <p><strong>Edition No:</strong> {publication.editionno}</p>
            <p><strong>Volume No:</strong> {publication.volnum}</p>
            <p><strong>ISBN:</strong> {publication.isbn}</p>
            <p><strong>ISSN:</strong> {publication.issn}</p>
            <p><strong>Issue Number:</strong> {publication.issuenum}</p>
            <p><strong>Page Range:</strong> {publication.pfrom} - {publication.pto}</p>
            <p><strong>Indexing:</strong> {publication.indexing}</p>
            <p><strong>Impact Factor:</strong> {publication.impactfactor}</p>
            <p><strong>Publication Date:</strong> {publication.publicationDate}</p>

            {/* Render additional publication details here */}
        </div>
    );
};

export default ViewPublications;
